import React, { Component, Fragment } from 'react';
import { cloneDeep } from 'lodash';
import { Col, Form, Input, Modal, Radio, Row, Select, Upload } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import Resources from '../scripts/resources';
import Rules from '../scripts/rules';

class CountryForm extends Component {
    constructor() {
        super();

        this.state = {
            fileList: []
        };

        this.formRef = React.createRef();
    }

    handleCategory = () => {
        this.formRef.current.setFieldsValue({ subCategory: undefined });
    }

    handleSubmit = () => {
        this.formRef.current.validateFields().then(values => {
            const formData = new FormData();

            formData.append('code', values.code);
            formData.append('name', values.name);

           

            if (values.image && values.image.fileList && values.image.fileList.length)
                formData.append('image', values.image.file, values.image.file.name);

            this.props.onSubmit(formData);
        });
    }

    handleWillUnmount = () => {
        this.formRef.current.resetFields();

        this.setState({ fileList: [] });
    }

    handleDidMount = (data = {}) => {
        const cloneData = cloneDeep(data);

        this.formRef.current.setFieldsValue(cloneData);

        this.setState({ editMode: !!cloneData.id });
    }

    render() {
        const { categories, onCancel, submitting, tags, visible } = this.props;
        const { fileList, editMode } = this.state;

        const props = {
            onRemove: file => {
                this.setState({ fileList: [] });
            },
            beforeUpload: file => {
                this.setState({ fileList: [file] });
                return false;
            },
            showUploadList: {
                showRemoveIcon: editMode
            },
            fileList
        };

        return (
            <Modal
                title={editMode ? Resources.edit : Resources.add}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={onCancel}
                okText={Resources.confirm}
                cancelText={Resources.cancel}
                okButtonProps={{ loading: submitting }}
                cancelButtonProps={{ disabled: submitting }}
                width={700}>
                <Form ref={this.formRef} layout="vertical">
                    <Row gutter={24}>
                      
                       
                        <Col xs={24}>
                            <Form.Item name="name" label={Resources.title} rules={Rules.required}>
                                <Input></Input>
                            </Form.Item>
                        </Col>
                        <Col xs={24}>
                            <Form.Item name="code" label={Resources.code} rules={Rules.required}>
                                <Input></Input>
                            </Form.Item>
                        </Col>
                  
                        <Col xs={24}>
                            <Form.Item name="image" label={Resources.image} >
                                <Upload.Dragger {...props}>
                                    <p className="ant-upload-drag-icon"><InboxOutlined /></p>
                                    <p className="ant-upload-hint">{Resources.uploadText}</p>
                                </Upload.Dragger>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        );
    }
};

export default CountryForm;